import FileResizer from 'react-image-file-resizer';

// Downscale to fit within 1920x1080, preserving the original format: PNGs are re-emitted as PNG
// (keeping transparency + losslessness for icons/logos), everything else as JPEG. Bounds the
// base64 the uploader embeds inline — an un-resized full-res PNG can be large enough to break
// the clinic save.
export const resizeImageTo1080pPreservingFormat = async (image: File): Promise<File | null> =>
  image.type === 'image/png' ? resizeImage(image, 'PNG') : resizeImage(image, 'JPEG');

export const resizeImageTo1080p = async (image: File): Promise<File | null> => resizeImage(image, 'JPEG');

const resizeImage = (image: File, format: 'JPEG' | 'PNG'): Promise<File | null> =>
  new Promise((resolve) => {
    const isPng = format === 'PNG';
    const fileName = isPng ? 'image.png' : 'image.jpeg';
    const type = isPng ? 'image/png' : 'image/jpeg';

    FileResizer.imageFileResizer(image, 1920, 1080, format, 100, 0, (resizedImage) => {
      if (typeof resizedImage === 'string') {
        fetch(resizedImage)
          .then((res) => res.blob())
          .then((blob) => resolve(new File([blob], fileName, { type })))
          .catch(() => resolve(null));
        return;
      }
      if (resizedImage instanceof File) {
        resolve(resizedImage);
        return;
      }
      // Unsupported callback value (Blob / ProgressEvent) — settle rather than leave it pending.
      resolve(null);
    });
  });
